import { WebPlugin } from '@capacitor/core';
import type { FeelNativePlugin, HIDDeviceInfo, PrintOptions, PrintProfile, RoomConfig } from './definitions';

export class FeelNativeWeb extends WebPlugin implements FeelNativePlugin {
  startAdvertising(): Promise<any> {
    throw new Error('Method not implemented.');
  }
  startDiscovery(): Promise<any> {
    throw new Error('Method not implemented.');
  }
  sendMessage(): Promise<any> {
    throw new Error('Method not implemented.');
  }
  stopAllConnections(): Promise<any> {
    throw new Error('Method not implemented.');
  }
  async createChatRoom(config: RoomConfig) {
    try {
      // Use the exposed API
      // @ts-expect-error
      if (window.electronAPI?.createChatRoom) {
        // @ts-expect-error
        return await window.electronAPI.createChatRoom(config);
      } else {
        throw new Error('Electron API is not available');
      }
    } catch (error) {
      console.error('Error during printing:', error);
      throw new Error('Failed to print.');
    }
  }
  async getAllPrinters(): Promise<any[]> {
    try {
      // Use the exposed API
      // @ts-expect-error
      if (window.electronAPI?.getPrinters) {
        // @ts-expect-error
        return await window.electronAPI.getPrinters();
      } else {
        throw new Error('Electron API is not available');
      }
    } catch (error) {
      console.error('Error during printing:', error);
      throw new Error('Failed to print.');
    }
  }
  // Print a receipt
  async print({ options, profile, data, address, printerName }: { options: PrintOptions, profile: PrintProfile, data: string, address: string, printerName: string }): Promise<void> {
    try {
      // Use the exposed API
      // @ts-expect-error
      if (window.electronAPI?.printReceipt) {
        // @ts-expect-error
        window.electronAPI.printReceipt(options, profile, data, address, printerName)
      } else {
        throw new Error('Electron API is not available');
      }
    } catch (error) {
      console.error('Error during printing:', error);
      throw new Error('Failed to print.');
    }
  }
  async initializeScanner() {
    try {
      //@ts-expect-error
      const devices = await window.hidAPI.getDevices();
      console.log('Connected devices:', devices);

      if (devices.length > 0) {
        await this.connectToScanner(devices[0]);
      } else {
        await this.requestNewDevice(0x1234);
      }
      return (devices || []) as HIDDeviceInfo[];
    } catch (error) {
      console.error('Error initializing scanner:', error);
      throw error
    }
  }
  async requestNewDevice(vendorId: number) {
    try {
      const filters = [{ vendorId }];
      //@ts-expect-error
      const device = await window.hidAPI.requestDevice(filters);
      await this.connectToScanner(device);
    } catch (error) {
      console.error('Error requesting device:', error);
    }
  }
  async connectToScanner(device: HIDDeviceInfo) {
    try {
      //@ts-ignore
      const connectedDevice = await window.hidAPI.connectToDevice(device);
      console.log('Connected to device:', connectedDevice.productName);
      connectedDevice.addEventListener('inputreport', (event: any) => {
        const barcode = new TextDecoder().decode(event.data.buffer);
        console.log('Scanned Barcode:', barcode);
        // addToCart(barcode);
      });
    } catch (error) {
      console.error('Error connecting to device:', error);
    }
  }
  async proompt({ apiKey, shopInfo }: { apiKey: string; shopInfo: { prompt: string; }; }): Promise<string> {
    try {
      //@ts-expect-error
      if (window.electronAPI?.proompt) {
        //@ts-expect-error
        return await window.electronAPI?.proompt({ apiKey, shopInfo })
      } else {
        throw new Error("Platform not supported")
      }
    } catch (error: any) {
      throw new Error(error.message);
    }
  }

}
